export default __webpack_public_path__ + "static/media/ishopifyHome.1f3ba976.png";